export default {
    ankara: 'آنکارا',
    antalya: 'آنتالیا',
    baku: 'باکو',
    bandarAbbas: 'بندرعباس',
    dubai: 'دبی',
    hongKong: 'هنگ کنگ',
    istanbul: 'استانبول',
    izmir: 'ازمیر',
    kerman: 'کرمان',
    kish: 'کیش',
    kualalumpur: 'کوالالامپور',
    kusadasi: 'کوش آداسی',
    marmaris: 'مارماریس',
    mashhad: 'مشهد',
    moscow: 'مسکو',
    qom: 'قم',
    pattaya: 'پاتایا',
    seychelles: 'سیشل',
    tehran: 'تهران',
    tbilisi: 'تفلیس',
    yazd: 'یزد',
};
